import { useContext, useMemo } from 'react'
import { AppCtx } from '../store'

export default function useSelector(fn) {
  let store = useContext(AppCtx);
  return useMemo(() => fn(store), [store, fn]);
}